//Configuration list for National map filters
export const nationalMapFiltersConfigList = [
    {
        name: "State",
        propID: "inState",
        listName: "executeRetrieveState",
        valueKey: "State",
        valueName: "State",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "SA4 Region",
        propID: "inLocationType",
        listName: "executeRetrieveLocationType",
        valueKey: "LocationType",
        valueName: "LocationType",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Investment Tier",
        propID: "inInvestmentTier",
        listName: "executeRetrieveInvestmentTier",
        valueKey: "InvestmentTier",
        valueName: "InvestmentTier",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Commonwealth Funded",
        propID: "inCommonwealthFunded",
        listName: "executeRetrieveCommonwealthFunded",
        valueKey: "CommonwealthFunding",
        valueName: "CommonwealthFunding",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Pipeline",
        propID: "inPipeline",
        listName: "executeRetrievePipeline",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Project Phase",
        propID: "inProjectPhase",
        listName: "executeRetrieveProjectPhase",
        valueKey: "PhaseType",
        valueName: "PhaseType",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Super Sector",
        propID: "inSuperSector",
        listName: "executeRetrieveSuperSector",
        valueKey: "SuperSector",
        valueName: "SuperSector",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Master Type",
        propID: "inMasterType",
        listName: "executeRetrieveMasterType",
        valueKey: "MasterType",
        valueName: "MasterType",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Project Type",
        propID: "inProjectType",
        listName: "executeRetrieveProjectType",
        valueKey: "RawProjectType",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: "ALL"
    }
];

export const labourShortageFiltersConfigList = [
    {
        name: "Group",
        propID: "inLvl1Group",
        listName: "executeRetrieveLvl1Group",
        valueKey: "Lvl1Group",
        valueName: "Lvl1Group",
        filters: {"PLEMGroup": ["Labour"]},
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Occupation",
        propID: "inResourceGroup",
        listName: "executeRetrieveResourceGroup",
        valueKey: "ResourceGroup",
        valueName: "ResourceGroup",
        filters: {"PLEMGroup": ["Labour"]},
        multiple: true,
        defaultValue: "ALL"
    }
];

export const nonLabourValueFiltersConfigList = [
    {
        name: "PLEM Group",
        propID: "inPLEMGroup",
        listName: "executeRetrievePLEMGroup",
        valueKey: "PLEMGroup",
        valueName: "PLEMGroup",
        filters: {"PLEMGroup": ["Equipment", "Material", "Plant"]},
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Resource Group",
        propID: "inResourceGroup",
        listName: "executeRetrieveResourceGroup",
        valueKey: "ResourceGroup",
        valueName: "ResourceGroup",
        filters: {"PLEMGroup": ["Equipment", "Material", "Plant"]},
        multiple: true,
        defaultValue: "ALL"
    }
];

export const nonLabourTonnageFiltersConfigList = [
    {
        name: "Resource Group",
        propID: "inResourceGroup",
        listName: "executeRetrieveResourceGroup",
        valueKey: "ResourceGroup",
        valueName: "ResourceGroup",
        filters: {"PLEMGroup": ["Material"]},
        multiple: true,
        defaultValue: "ALL"
    }
];